import template from './requiredDocumentsPreview.html';
import RequiredDocumentsPreviewCtrl from './requiredDocumentsPreviewCtrl';

export default {
  template,
  controller: RequiredDocumentsPreviewCtrl,
  controllerAs: 'vm',
};
